import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import { compose, applyMiddleware, createStore as createReduxStore } from 'redux';
// utilities
import { history } from './utilities';
// root
import mainSaga from './saga';
import reducer from './reducer';
//////////////////////////////////////////////////

const initialState = {};

export const createStore = (mainSaga, ...additionalMiddlewares) => {
  const sagaMiddleware = createSagaMiddleware();

  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
    additionalMiddlewares.push(logger);
  }

  const middleWares = [sagaMiddleware, ...additionalMiddlewares];

  const composes = [applyMiddleware(...middleWares)];

  const store = createReduxStore(reducer, initialState, compose(...composes));

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      store.replaceReducer(reducer);
    });
  }

  sagaMiddleware.run(mainSaga, history);

  return store;
};

let store = createStore(mainSaga, routerMiddleware(history)); // eslint-disable-line

export default store;
